import {
  faBookmark,
  faCalendar,
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDays,
  faCalendarTimes,
  faCircle,
  faCheckCircle,
  faClock,
  faComment,
  faCommentAlt,
  faCopy,
  faFaceGrin,
  faFileAlt,
  faFileArchive,
  faFileAudio,
  faFileCode,
  faFileExcel,
  faFileImage,
  faFile,
  faFilePdf,
  faFilePowerpoint,
  faFileVideo,
  faFileWord,
  faLifeRing,
  faLightbulb,
  faThumbsUp,
  faTimesCircle,
  faSmile,
  faSquare,
  faStar,
  faQuestionCircle
} from '@fortawesome/free-regular-svg-icons';

const regularIcons = {
  bookmark: faBookmark,
  calendar: faCalendar,
  'calendar-alt': faCalendarAlt,
  'calendar-days': faCalendarDays,
  'calendar-check': faCalendarCheck,
  'calendar-times': faCalendarTimes,
  circle: faCircle,
  'check-circle': faCheckCircle,
  clock: faClock,
  comment: faComment,
  'comment-alt': faCommentAlt,
  copy: faCopy,
  'face-grin': faFaceGrin,
  'file-alt': faFileAlt,
  'file-archive': faFileArchive,
  'file-audio': faFileAudio,
  'file-code': faFileCode,
  'file-excel': faFileExcel,
  'file-image': faFileImage,
  file: faFile,
  'file-pdf': faFilePdf,
  'file-powerpoint': faFilePowerpoint,
  'file-video': faFileVideo,
  'file-word': faFileWord,
  'life-ring': faLifeRing,
  lightbulb: faLightbulb,
  'thumbs-up': faThumbsUp,
  'times-circle': faTimesCircle,
  smile: faSmile,
  square: faSquare,
  star: faStar,
  'question-circle': faQuestionCircle
};

export type RegularIcon = keyof typeof regularIcons;
export default Object.values(regularIcons);
